/* eslint-disable react/no-danger */
import { Box, Text } from "@mantine/core";
import { CLINICAL_RICH_TEXT_CLASS } from "../../utils/clinicalRichText";
import { formatDiagnosisHeading } from "./diagnosisHeading";
import {
  CLINICAL_REPORT_BODY_STYLE,
  CLINICAL_REPORT_FONT_FAMILY,
} from "./reportTypography";

interface SpecimenDiagnosis {
  specimenId: string;
  specimenLabel: string;
  specimenSource: string;
  specimenSubsite?: string | null;
  findings?: string | null;
  procedure?: string | null;
  diagnosisText: string;
}

interface DiagnosisSectionProps {
  label: string;
  diagnoses: SpecimenDiagnosis[];
  showHeading?: boolean;
  startIndex?: number;
}

// Per GI report spec — DIAGNOSIS block typography.
const dxSectionLabelStyle: React.CSSProperties = {
  fontFamily: CLINICAL_REPORT_FONT_FAMILY,
  fontSize: "12pt",
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  margin: 0,
};
const dxSpecimenLetterStyle: React.CSSProperties = {
  fontFamily: CLINICAL_REPORT_FONT_FAMILY,
  fontSize: "11pt",
  fontWeight: 400,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  whiteSpace: "nowrap",
  flexShrink: 0,
  paddingLeft: "10.5pt",
  minWidth: "31.7pt",
};
const dxSiteLabelStyle: React.CSSProperties = {
  fontFamily: CLINICAL_REPORT_FONT_FAMILY,
  fontSize: "11pt",
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
};
export function DiagnosisSection({
  label,
  diagnoses,
  showHeading = true,
  startIndex = 0,
}: DiagnosisSectionProps) {
  if (diagnoses.length === 0) return null;

  return (
    <Box mt={showHeading ? 12 : 0}>
      {showHeading && <Text style={dxSectionLabelStyle}>{label}</Text>}
      {diagnoses.map((d, index) => {
        const actualIndex = startIndex + index;
        return (
          <Box
            key={d.specimenId}
            mt={actualIndex === 0 ? 4 : "12.7pt"}
            style={{ breakInside: "avoid" }}
          >
            <Box style={{ display: "flex", alignItems: "baseline", gap: 0 }}>
              <span style={dxSpecimenLetterStyle}>
                {String.fromCharCode(65 + actualIndex)}.
              </span>
              <span style={dxSiteLabelStyle}>
                {formatDiagnosisHeading({
                  source: d.specimenSource,
                  subsite: d.specimenSubsite,
                  findings: d.findings,
                  procedure: d.procedure,
                  uppercaseAnatomy: true,
                })}
              </span>
            </Box>
            {d.diagnosisText ? (
              <Box
                className={CLINICAL_RICH_TEXT_CLASS}
                style={{
                  paddingLeft: "31.7pt",
                  ...CLINICAL_REPORT_BODY_STYLE,
                }}
                dangerouslySetInnerHTML={{ __html: d.diagnosisText }}
              />
            ) : (
              <Text
                c="dimmed"
                fs="italic"
                style={{
                  ...CLINICAL_REPORT_BODY_STYLE,
                  paddingLeft: "31.7pt",
                  fontWeight: 400,
                }}
              >
                No diagnosis entered
              </Text>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
